import Vue from 'vue'
import "@/common/config/init"

Vue.config.productionTip = false

// 根据环境变量动态导入不同的主页组件
const resourceDir = process.env.VUE_APP_RESOURCE_DIR || 'default'

// 动态加载组件函数
function loadComponent() {
  // 如果有指定资源目录且不为默认值
  if (resourceDir && resourceDir !== 'default') {
    // 返回一个动态导入函数，它会先尝试加载特定环境的组件，失败则加载默认组件
    return () => import(`./home.${resourceDir}.vue`)
      .catch(() => import('./home.vue'))
  } else {
    // 默认情况下加载普通组件
    return () => import('./home.vue')
  }
}

const App = loadComponent()

App().then(Module => {
  const AppComponent = Module.default || Module
  new Vue({
    render: h => h(AppComponent),
  }).$mount('#app')
})